// extracted by mini-css-extract-plugin
module.exports = {"loader":"_abb710b","loaderAnimation":"_b5334e7"};